import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function Cursos() {
  const courses = [
    { title: "Kinder", description: "4 a 6 años", link: "/courses/Kinder", icon: "🌟", tag: "Presencial" },
    { title: "Niños", description: "6 a 10 años", link: "/courses/Ninos", icon: "📖", tag: "Presencial" },
    { title: "Jóvenes", description: "11 a 15 años", link: "/courses/Jovenes", icon: "🎯", tag: "Presencial" },
    { title: "Adultos", description: "+15 años", link: "/courses/Adultos", icon: "👤", tag: "Presencial · Online" },
    { title: "Inglés Intensivo", description: "Todas las edades", link: "/courses/Intensivo", icon: "🚀", tag: "Presencial · Online" },
    { title: "Clases Privadas", description: "Todas las edades", link: "/courses/Privadas", icon: "🎓", tag: "A convenir" },
    { title: "Clases Empresariales", description: "Para el trabajo", link: "/courses/Empresas", icon: "🏢", tag: "In-company · Online" },
    { title: "Preparación para Examen", description: "+15 años", link: "/courses/PreparacionExamen", icon: "📝", tag: "Cambridge · CENNI" },
    { title: "Curso de Verano", description: "Para niños", link: "/SummerCamp", icon: "☀️", tag: "Verano" },
    { title: "Certificaciones", description: "De acuerdo a tu nivel", link: "/Certificaciones-Ingles", icon: "🏆", tag: "Cambridge · CENNI · ELeT" },
    { title: "Español para Extranjeros", description: "Learn Spanish in Mexico", link: "/Spanish", icon: "🇲🇽", tag: "Presencial · Online" },
    { title: "Inglés Garantizado", description: "Si repruebas, repites gratis.", link: "/contacto", icon: "✅", tag: "Garantía" },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Cursos de Inglés | Culturlingua — Tlaquepaque y Online</title>
        <meta name="description" content="Explora todos los cursos de inglés en Culturlingua: Kinder, niños, jóvenes, adultos, intensivo, empresarial, certificaciones y más." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Todos los niveles</div>
        <h1>Nuestros Cursos</h1>
        <p>Desde Kinder hasta certificaciones internacionales. Hay un curso para cada persona.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1200px', margin:'0 auto'}}>
          <div style={{textAlign:'center', marginBottom:'60px'}}>
            <p className="section-sub" style={{margin:'0 auto'}}>
              En Culturlingua ofrecemos cursos presenciales en Tlaquepaque y online desde cualquier lugar.
              Todos con profesores certificados y metodología MCER.
            </p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:'20px'}}>
            {courses.map((course, i) => (
              <Link to={course.link} key={i} style={{textDecoration:'none'}}>
                <div className="modal-card" style={{height:'100%', cursor:'pointer'}}>
                  <div className="modal-card-accent"></div>
                  <div className="modal-card-body">
                    <div style={{fontSize:'2.2rem', marginBottom:'12px'}}>{course.icon}</div>
                    <h3 style={{marginBottom:'6px'}}>{course.title}</h3>
                    <p style={{marginBottom:'16px'}}>{course.description}</p>
                    <span style={{
                      background:'rgba(59,111,224,0.08)', color:'var(--blue)',
                      border:'1px solid rgba(59,111,224,0.2)', padding:'3px 10px',
                      borderRadius:'100px', fontSize:'0.75rem', fontWeight:'600'
                    }}>{course.tag}</span>
                    <div className="modal-link" style={{marginTop:'20px'}}>Ver detalles →</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'48px', textAlign:'center', marginTop:'60px'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.8rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿No sabes cuál elegir?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'32px'}}>
              Haz el examen de ubicación gratis o contáctanos y te orientamos.
            </p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/Examen-de-ubicacion" className="btn-glow">Examen de ubicación gratis</Link>
              <Link to="/EncuentraTuCurso" className="btn-outline">Encuentra tu curso →</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Cursos;
